import React from "react";
import { Route, Switch, BrowserRouter as Router, Redirect } from "react-router-dom";
import Login from "./components/Users/Login";
import AdminUserForm from "./components/Adm/UserForm";
import UserList from "./components/Adm/UserList";

import SaleForm from "./components/Ven/SaleForm";
import AdminDrawer from "./components/Adm/Drawer";
import CompanyList from "./components/Adm/CompanyList";

import Home from "./components/Home";

import SalesList from "./components/SalesList";
import SaleDetail from "./components/SaleDetail";
import PostsList from "./components/PostsList";
import PostForm from "./components/Adm/PostForm";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import AdminRoute from "./components/Auth/AdminRoute";
import EmployeeRoute from "./components/Auth/EmployeeRoute";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Switch>
          <Route exact path="/login" component={Login} />
          <AdminRoute exact path="/users" component={UserList} />
          <AdminRoute exact path="/new-user" component={AdminUserForm} />
          <ProtectedRoute exact path="/home" component={Home} />
          <ProtectedRoute exact path="/new-sale" component={SaleForm} />
          <AdminRoute exact path="/" component={AdminDrawer} />
          <AdminRoute exact path="/companies" component={CompanyList} />
          <AdminRoute exact path="/sales" component={SalesList} />
          <AdminRoute exact path="/sales/:id" component={SaleDetail} />
          <ProtectedRoute exact path="/my-sales" component={SalesList} />
          <ProtectedRoute exact path="/my-sales/:id" component={SaleDetail} />
          <EmployeeRoute exact path="/seller-panel" component={PostsList} />
          <AdminRoute exact path="/admin/posts/new" component={PostForm} />
          <Redirect to="/login" />
        </Switch>
      </Router>
    </AuthProvider>
  );
};

export default App;
